/* <radar-cart-side>: la colonna si rifa' quando il carrello cambia.

   Il carrello del tema si aggiorna da solo senza ricaricare la pagina, e
   rifa' soltanto le parti che ha in elenco: la tabella dei capi e il
   contatore nell'intestazione (assets/cart.js, getSectionsToRender). Questa
   colonna non e' in quell'elenco, quindi chi aggiungeva un capo per
   arrivare allo scaglione dopo continuava a leggere "aggiungine 7" anche
   dopo averne aggiunto uno.

   Invece di mettere le mani in quell'elenco - che e' del tema e cambia coi
   suoi aggiornamenti - si ascolta l'avviso che manda gia' a lavoro finito,
   e ci si richiede da soli al negozio. Se l'avviso un domani cambia nome,
   la colonna smette di aggiornarsi da sola: resta giusta al caricamento,
   non sbagliata. */
(function (global) {
  'use strict';

  if (typeof HTMLElement !== 'function') return;

  var RadarCartSide = class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.rifai = this.rifai.bind(this);
      global.document.addEventListener('line-item:change:end', this.rifai);
    }

    disconnectedCallback() {
      global.document.removeEventListener('line-item:change:end', this.rifai);
    }

    async rifai() {
      var sezione = this.dataset.sezione;
      if (!sezione) return;
      try {
        var risposta = await fetch(global.location.pathname + '?section_id=' + encodeURIComponent(sezione));
        if (!risposta.ok) return;
        var testo = await risposta.text();
        var fresco = new DOMParser().parseFromString(testo, 'text/html').querySelector('radar-cart-side');
        // Niente elemento nella risposta vuol dire che il negozio ha
        // risposto qualcos'altro: meglio lasciare quello che c'e' che
        // svuotare la colonna.
        if (fresco) this.innerHTML = fresco.innerHTML;
      } catch (e) {
        /* Una rete che cade non deve lasciare la colonna a meta'. */
      }
    }
  };

  if (!customElements.get('radar-cart-side')) customElements.define('radar-cart-side', RadarCartSide);
})(typeof window !== 'undefined' ? window : globalThis);
